import React from 'react';
import { User as UserIcon, Calendar, Mail, Phone, LogOut } from 'lucide-react';
import { UserProfile } from '../../types';
import FontSizeSelector from '../FontSizeSelector';

interface PersonalStepProps {
  formData: UserProfile;
  errors: Record<string, string>;
  onFieldChange: (field: string, value: any) => void;
  onLogout?: () => void;
  formatDateLong: (dateStr: string) => string;
}

export default function PersonalStep({
  formData,
  errors,
  onFieldChange,
  onLogout,
  formatDateLong
}: PersonalStepProps) {
  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <label className="text-[10px] font-bold text-zinc-400 uppercase tracking-widest ml-1">Seu Nome (Assinatura)</label>
        <div className="relative">
          <UserIcon className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-zinc-400" />
          <input
            type="text"
            value={formData.ownerName || ''}
            onChange={(e) => onFieldChange('ownerName', e.target.value)}
            className={`w-full bg-white border ${errors.ownerName ? 'border-rose-500' : 'border-zinc-100'} rounded-2xl py-4 pl-12 pr-4 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 transition-all`}
            placeholder="Seu nome completo"
          />
        </div>
        {errors.ownerName && <p className="text-[10px] text-rose-500 font-bold ml-1">{errors.ownerName}</p>}
      </div>

      <div className="space-y-1">
        <label className="text-[10px] font-bold text-zinc-400 uppercase tracking-widest ml-1">Nascimento</label>
        <div className="relative">
          <Calendar className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-zinc-400" />
          <input
            type="date"
            value={formData.birthDate || ''}
            onChange={(e) => onFieldChange('birthDate', e.target.value)}
            className={`w-full bg-white border ${errors.birthDate ? 'border-rose-500' : 'border-zinc-100'} rounded-2xl py-4 pl-12 pr-4 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 transition-all`}
          />
        </div>
        {formData.birthDate && <p className="text-[10px] text-zinc-500 ml-1">{formatDateLong(formData.birthDate)}</p>}
        {errors.birthDate && <p className="text-[10px] text-rose-500 font-bold ml-1">{errors.birthDate}</p>}
      </div>

      <div className="space-y-1">
        <label className="text-[10px] font-bold text-zinc-400 uppercase tracking-widest ml-1">E-mail</label>
        <div className="relative">
          <Mail className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-zinc-400" />
          <input
            type="email"
            value={formData.email || ''}
            onChange={(e) => onFieldChange('email', e.target.value)}
            className={`w-full bg-white border ${errors.email ? 'border-rose-500' : 'border-zinc-100'} rounded-2xl py-4 pl-12 pr-4 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 transition-all`}
            placeholder="seu@email.com"
          />
        </div>
        {errors.email && <p className="text-[10px] text-rose-500 font-bold ml-1">{errors.email}</p>}
      </div>

      <div className="space-y-1">
        <label className="text-[10px] font-bold text-zinc-400 uppercase tracking-widest ml-1">WhatsApp</label>
        <div className="relative">
          <Phone className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-zinc-400" />
          <input
            type="tel"
            value={formData.phone || ''}
            onChange={(e) => onFieldChange('phone', e.target.value)}
            className={`w-full bg-white border ${errors.phone ? 'border-rose-500' : 'border-zinc-100'} rounded-2xl py-4 pl-12 pr-4 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 transition-all`}
            placeholder="(00) 00000-0000"
          />
        </div>
        {errors.phone && <p className="text-[10px] text-rose-500 font-bold ml-1">{errors.phone}</p>}
      </div>

      <div className="pt-6 pb-2 border-t border-zinc-100">
        <FontSizeSelector />
      </div>

      {onLogout && (
        <button
          onClick={async () => {
            try {
              await onLogout();
            } catch (err) {
              console.error('Erro ao sair:', err);
              alert('Ocorreu um erro ao sair da conta. Tente novamente.');
            }
          }}
          className="text-red-500 border border-red-100 hover:bg-red-50 py-3 rounded-xl w-full mt-8 font-bold text-sm transition-colors flex items-center justify-center gap-2"
        >
          <LogOut className="w-4 h-4" />
          Sair ou Trocar de Conta
        </button>
      )}
    </div>
  );
}
